import React from 'react';
import { Link } from 'react-router-dom';
import './GetStarted.css';

export default function AboutUs() {
    return (
        <section id="get-started-section" className="about-us-section get-started-section">
            <div className="get-started-container">
                <div className="get-started-content">
                    {/* Left Side - Image */}
                    <div className="get-started-image">
                        <div className="get-started-image-wrapper">
                            <img 
                                src="/images/what-sets-apart-us.jpeg" 
                                alt="Music Education" 
                                className="get-started-img"
                            />
                        </div>
                    </div>

                    {/* Right Side - Content */}
                    <div className="about-us-info get-started-info">
                        <div className="get-started-header">
                            <h2 className="section-title">About Us</h2>
                            <div className="section-divider"></div>
                        </div>
                        <div className="get-started-description">
                            <p>Harshita School of Music (HSM), founded by Harshita Rewadia, India’s first Opera Queen and renowned Western Vocalist, is a professional academy dedicated to nurturing musical talent with passion, precision, and purpose. With 350+ students across diverse disciplines—ranging from Western Vocals, Bollywood Singing, Hindustani Classical, to Instrumental mastery in Guitar, Keyboard, Drums, and more—HSM has become a trusted name in holistic music education.</p>
                            <p>We believe music is not just an art, but a journey of self-discovery and expression. At HSM, students receive world-class training under specialized teachers for every subject, ensuring individual attention and structured growth. Our programs cater to both hobby learners and aspiring professionals, helping them build careers in music while enjoying every step of the process.</p>
                        </div>
                        <div className="get-started-actions">
                            <Link to="/admission-form" className="get-started-btn">
                                Join Us
                            </Link>
                            <Link to="/about-us" className="get-started-btn">
                                Know More
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}